import { Link, Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Logo } from '@/components/common/Logo';
import { ROUTES } from '@/constants/routes';

export function AuthLayout() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-hero-glow px-4 py-12">
      <div
        className="pointer-events-none absolute inset-0 bg-grid-pattern [background-size:56px_56px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_40%,black,transparent)]"
        aria-hidden
      />

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="relative w-full max-w-md"
      >
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>
        <div className="glass-strong p-7 shadow-card sm:p-8">
          <Outlet />
        </div>
        <p className="mt-6 text-center text-xs text-zinc-600">
          <Link to={ROUTES.home} className="transition-colors hover:text-zinc-400">
            ← Back to home
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
